import React from "react";
import { EstimatedBehaviorCategoryList } from "../../../../domain/estimated_behavior/EstimatedBehaviorCategories";
import { useCareRecipientIdFromPath } from "../../../hooks/care_recipient/useCareRecipientIdFromPath";
import { useInput } from "../../../hooks/common/useInput";
import { Button } from "../../common/button/Button";
import { InputTextArea } from "../../common/input/InputTexArea";

export function AdminTestDataRegister() {
    const careRecipientId = useCareRecipientIdFromPath();
    
    const defaultEstimatedBehaviorJson = "{\"date\": \"YYYY-MM-DD\", \"category\": \"カテゴリのどれか\", \"startTime\": \"YYYY-MM-DD hh:mm:ss\", \"endTime\": \"YYYY-MM-DD hh:mm:ss\"}";

    const [estimatedBehaviorJson, , handleEstimatedBehaviorJson] = useInput(defaultEstimatedBehaviorJson);

    const categoryList = [...EstimatedBehaviorCategoryList.map(category => category.key.toUpperCase()), "GOING_OUT"].join(" / ");

    const saveEstimatedBehavior = () => {

        if (!careRecipientId) return;

        fetch(`/api/test_data/estimated_behavior/${careRecipientId.value}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8" // eslint-disable-line
            },
            body: estimatedBehaviorJson
        }).then((result) => {
            const message = result.ok ? "登録成功" : "登録失敗";
            alert(message);
        });
    };

    return (
        <div style={{ padding: "16px" }}>
            {/* 利用者ID */}
            <div style={{ fontWeight: "bold", padding: "8px", textAlign: "left" }}>利用者：{careRecipientId?.value ?? ""}</div>

            {/* カテゴリ一覧 */}
            <div style={{ fontWeight: "bold", padding: "8px", textAlign: "left" }}>カテゴリ：{categoryList}</div>

            {/* 注意 */}
            <div style={{ color: "red", fontWeight: "bold", padding: "8px", textAlign: "left" }}>
                日を跨ぐデータは、〜MM/DD 23:59とMM/DD 00:00〜で分けて登録してください。
            </div>

            {/* estimated_behavior入力 */}
            <InputTextArea value={estimatedBehaviorJson} handleTextChanged={handleEstimatedBehaviorJson}/>
            
            <div style={{ padding: "8px" }}>
                <Button label="保存" onClick={saveEstimatedBehavior} width={100} />
            </div>
        </div>
    );
}
